import { createReducer, on } from '@ngrx/store';
import { INotification } from '../event-store/interfaces/event.interface';
import { NotificationActions } from './notification.actions';

export const notificationFeatureKey = 'notification';

export interface State {
  notifications: INotification[];
  /** True once a load has completed, so the bell can tell "none" from "not fetched yet". */
  loaded: boolean;
  loading: boolean;
  error: unknown;
}

export const initialState: State = {
  notifications: [],
  loaded: false,
  loading: false,
  error: null,
};

export const reducer = createReducer(
  initialState,

  /**
   * A poll tick must not raise `loading`: the header bell is always mounted, so a spinner every
   * minute would flicker over a list that is almost always unchanged. Only the very first load,
   * before anything is on screen, is worth reporting.
   */
  on(
    NotificationActions.loadNotifications,
    (state): State => ({ ...state, loading: !state.loaded }),
  ),

  on(
    NotificationActions.loadNotificationsSuccess,
    (state, { notifications }): State => ({
      ...state,
      notifications,
      loaded: true,
      loading: false,
      error: null,
    }),
  ),

  on(
    NotificationActions.loadNotificationsFailure,
    (state, { error }): State => ({ ...state, loading: false, error }),
  ),

  on(
    NotificationActions.markReadSuccess,
    (state, { notification }): State => ({
      ...state,
      notifications: state.notifications.map((n) =>
        n.id === notification.id ? notification : n,
      ),
    }),
  ),

  on(
    NotificationActions.markAllReadSuccess,
    (state, { readAt }): State => ({
      ...state,
      notifications: state.notifications.map((n) => (n.read_at ? n : { ...n, read_at: readAt })),
    }),
  ),
);
